const noUserAddres = (user) => (user?.alternativeDirections?.length > 0 ? user?.alternativeDirections[0].address : 'Lo llevaré a la transportadora');

const userAddressSelected = (user, initExpressAddress, senderAddress = null) => {
  if (senderAddress === 'Lo llevaré a la transportadora') return initExpressAddress || user.address || noUserAddres(user);
  return senderAddress || noUserAddres(user);
};

export default userAddressSelected;
